import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { getDatasetFrequency } from '../utils/aggregationUtils'

const DatasetContext = createContext()

export const DatasetProvider = ({dataset, index, handleUpdateDataset, getColumns, datasets, children}) => {
    const [currentDataset, setCurrentDataset] = useState({})

    const columns = useMemo(() => getColumns && currentDataset.datasetValue && getColumns(currentDataset.datasetValue, datasets), [currentDataset.datasetValue, getColumns, datasets])
    
    useEffect(() => {setCurrentDataset({...dataset[index] ?? {}});return () => {}}, [dataset]) // eslint-disable-line

    const originalFrequency = dataset[index]?.datasetValue && getDatasetFrequency(datasets, dataset[index]?.datasetValue)

    const handleUpdateData = (column, dataset = currentDataset) =>{handleUpdateDataset(index, {...dataset, ...column, group: '',agg:'', granularity: []})}

    const removeDataset = () => {
        handleUpdateDataset(index)
        setCurrentDataset({})
    }

    const changeColumn = (columnValue,columnName,dataset) => {

        handleUpdateData({ columnValue,columnName },dataset ? {...currentDataset,datasetValue:dataset.value,datasetName:dataset.name,althub_client_id:dataset.althub_client_id,althub_dataset_id:dataset.althub_dataset_id} : currentDataset)}

    const changeDataset = (datasetValue, datasetName,althub_client_id,althub_dataset_id, granularity = {}) => setCurrentDataset(cData => ({...cData, datasetValue,datasetName,althub_client_id,althub_dataset_id, granularity}))

    return (
        <DatasetContext.Provider value={{
            originalFrequency: originalFrequency?.toLowerCase(),
            columns,
            datasets,
            changeColumn,
            changeDataset,
            currentDataset,
            removeDataset,
            index,
            handleUpdateData
        }}>
            { children}
        </DatasetContext.Provider>
    )

}

export function useDataset() {
    return useContext(DatasetContext)
}